import { apiClient } from '@/shared/api/client'

export const getNotifications = async (params = {}) => {
  const response = await apiClient.get('/notifications', { params })
  return response.data?.data || []
}

export const getUnreadNotificationCount = async () => {
  const response = await apiClient.get('/notifications/unread-count')
  return response.data?.data?.count || 0
}

export const markNotificationsAsRead = async (notificationIds) => {
  const response = await apiClient.patch('/notifications/read', {
    notificationIds,
  })
  return response.data
}

export const markAllNotificationsAsRead = async () => {
  const response = await apiClient.patch('/notifications/read-all')
  return response.data
}

export const deleteNotification = async (notificationId) => {
  const response = await apiClient.delete(`/notifications/${notificationId}`)
  return response.data
}
